import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { isInternalURI } from '../helpers/location';
import { breakpoints } from '../constants/mediaqueries';

import ExternalLink from './ExternalLink';
import ImageTitleCaption from './ImageTitleCaption';
import LocalisedLink from './LocalisedLink';
import MichelbergerImage from './MichelbergerImage';


const Wrapper = styled.div`
  @media ${breakpoints.l} {
    display: flex;
    justify-content: space-between;
  }
`;

const ImgWrap = styled.div`
  margin-bottom: 3.125rem; /* 50/16 */

  > a {
    display: block;
  }

  @media ${breakpoints.l} {
    width: calc(50% - 4vw);
    margin-bottom: 0;
  }
`;

const TwoImageBlock = ({ block }) => {
  const { imageOne, imageUrlOne, imageTwo, imageUrlTwo, changesColorOnHoverOne, changesColorOnHoverTwo, hasBlendModeOne, hasBlendModeTwo } = block;

  const mbImageOne = (
    <MichelbergerImage
      changesColorOnHover={changesColorOnHoverOne}
      hasBlendMode={hasBlendModeOne}
      image={imageOne}
    />
  );

  const mbImageTwo = (
    <MichelbergerImage
      changesColorOnHover={changesColorOnHoverTwo}
      hasBlendMode={hasBlendModeTwo}
      image={imageTwo}
    />
  );

  return (
    <Wrapper>
      <ImgWrap>
        <Choose>
          <When condition={imageUrlOne && isInternalURI(imageUrlOne)}>
            <LocalisedLink hasUnderline={false} to={imageUrlOne}>{mbImageOne}</LocalisedLink>
          </When>
          <When condition={imageUrlOne}>
            <ExternalLink hasUnderline={false} href={imageUrlOne}>{mbImageOne}</ExternalLink>
          </When>
          <Otherwise>
            {mbImageOne}
          </Otherwise>
        </Choose>
        <ImageTitleCaption caption={block.captionOne} title={block.titleOne} url={imageUrlOne} />
      </ImgWrap>
      <ImgWrap>
        <Choose>
          <When condition={imageUrlTwo && isInternalURI(imageUrlTwo)}>
            <LocalisedLink hasUnderline={false} to={imageUrlTwo}>{mbImageTwo}</LocalisedLink>
          </When>
          <When condition={imageUrlTwo}>
            <ExternalLink hasUnderline={false} href={imageUrlTwo}>{mbImageTwo}</ExternalLink>
          </When>
          <Otherwise>
            {mbImageTwo}
          </Otherwise>
        </Choose>
        <ImageTitleCaption caption={block.captionTwo} title={block.titleTwo} url={imageUrlTwo} />
      </ImgWrap>
    </Wrapper>
  );
};


TwoImageBlock.propTypes = {
  block: PropTypes.object.isRequired,
};

export default TwoImageBlock;
